import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'net_terms',
  inputShow: gql`
    query netTerms($input: NetTermQueryInput) {
      netTerms(input: $input) {
        id
        number_of_days
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
  },
};
